const configKeys = {
  IS_CREATE_DEFAULT_ILLUSTRATION_ENABLED: 'isCreateDefaultIllustrationEnabled',
  IS_UPDATE_DEFAULT_ILLUSTRATION_ENABLED: 'isUpdateDefaultIllustrationEnabled',
  IS_UPDATE_REGIONAL_ILLUSTRATION_ENABLED:
    'isUpdateRegionalIllustrationEnabled',
  IS_CREATE_ICON_ENABLED: 'isCreateIconEnabled',
  IS_UPDATE_ICON_ENABLED: 'isUpdateIconEnabled',
  IS_CREATE_ANIMATED_ILLUSTRATION_ENABLED:
    'isCreateAnimatedIllustrationEnabled',
  IS_UPDATE_ANIMATED_ILLUSTRATION_ENABLED:
    'isUpdateAnimatedIllustrationEnabled',
  IS_CREATE_ANIMATED_ICON_ENABLED: 'isCreateAnimatedIconEnabled',
  IS_UPDATE_ANIMATED_ICON_ENABLED: 'isUpdateAnimatedIconEnabled',
};

export default configKeys;
export let configKeysList = Object.values(configKeys);
